import ErrorTypes from "../../enums/errorTypes";
import { ActionTypes } from "../actionTypes";
import { actionCreator } from "../appAction";

export const setError = actionCreator<ActionTypes.SET_ERROR, ErrorTypes>(ActionTypes.SET_ERROR);
export const resetError = actionCreator<ActionTypes.RESET_ERROR, ErrorTypes>(ActionTypes.RESET_ERROR);
